import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { twMerge } from "tailwind-merge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/molecules/Dropdown";
import Chat from "@/entities/Chat";

interface Props {
  active?: boolean;
  chat: Chat;
  onSelect: (chat: Chat) => void
}

export default function ChatItem({ active, chat, onSelect }: Props) {
  return (
    <div
      className={twMerge(
        "flex items-center justify-between gap-4 p-2 py-1 rounded-md hover:bg-card cursor-default transition-all",
        active && "bg-card"
      )}
      onClick={() => onSelect(chat)}
    >
      <span title={chat.name} className="w-[200px] text-ellipsis overflow-hidden text-nowrap">
        {chat.name || "New Chat"}
      </span>

      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className="flex flex-col items-center justify-center rounded-full cursor-pointer hover:bg-card gap-1 w-10 h-10">
            <Ellipsis size={20} />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="dark bg-background w-[150px]">
          <DropdownMenuLabel>Options</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem>
            <Pencil size={18} className="mr-2" />
            <span>Rename</span>
          </DropdownMenuItem>
          <DropdownMenuItem className="text-destructive hover:text-destructive">
            <Trash2 size={18} className="mr-2 text-destructive hover:text-destructive" />
            <span className="text-destructive hover:text-destructive">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
